import React from 'react'
import Reflux from 'reflux'
import {
	Card,
	CardBody,
	CardTitle,
	Table
} from 'reactstrap'
import _ from 'lodash'

import IngredientsStore from '~/stores/ingredients'
// import IngredientsActions from '~/actions/ingredients.js'
import ModalIngredientListRow from '~/modules/modals/ingredients/listRow.jsx'
import ModalIngredientListFilterBar from '~/modules/modals/ingredients/listFilterBar.jsx'


export default class RecipeIngredientsModalList extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = IngredientsStore
	}

	render() {
		const ingredientList = (
			_.has(this.state, 'ingredients')
			&& _.size(this.state.ingredients) > 0
		)
			? this.state.ingredients.map(
				theIngredient => ((
						this.state.ingredientFilterLetter === theIngredient.firstLetter
						|| this.state.ingredientFilterLetter === ''
					)
						? (
							<ModalIngredientListRow
								key={theIngredient.ingredientID}
								ingredientID={theIngredient.ingredientID}
								ingredient={theIngredient.ingredient}
							/>
						)
						: null
			))
			: null

		return (
			<Card body inverse color="secondary">
				<CardTitle>
					Existing Ingredients
				</CardTitle>
				<CardBody style={{ margin: 0, padding: 0 }}>
					<ModalIngredientListFilterBar />

					<br />
					<br />

					<Table size="sm" striped>
						<thead>
							<tr>
								<th style={{ width: '80%' }}>Ingredient</th>
								<th style={{ width: '10%' }} />
								<th style={{ width: '10%' }} />
							</tr>
						</thead>
						<tbody>
							{ingredientList}
						</tbody>
					</Table>
				</CardBody>
			</Card>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/ingredients/list.jsx